<template>
  <div class="text-gray-500 border-t border-gray-200 pt-8">
    <h3 class="font-medium text-xl lg:text-2xl text-gray-700 mb-2">
      Methodology
    </h3>
    <p
      class="text-gray-600 mt-2 text-base"
      v-html="methodologyText"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { generateSalaryMethodologyText } from '~/utils/salaryMethodology'

interface Props {
  companyName: string
  permalink: string
  sampleSize?: number
}

const props = defineProps<Props>()

const methodologyText = computed(() => {
  return generateSalaryMethodologyText(props.companyName, props.sampleSize, {
    withHyperlinks: true,
    permalink: props.permalink
  })
})
</script>
